/* eslint-disable prefer-destructuring */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { FaPaperPlane } from 'react-icons/fa';
import { IoRocketSharp } from 'react-icons/io5';
import { GoRocket } from 'react-icons/go';
import { RiRocket2Fill } from 'react-icons/ri';

interface custom {
    name: string,
    distCount: number,
    totalCount: number
}
const Protocol = ({
  name, distCount, totalCount,
}: custom) => {
  const ImagesProtocol = () => {
    let pname = name.split('-')[1];
    if (pname) {
      pname = pname.trim();
    } else {
      pname = name.trim();
    }
    if (pname.includes('RPC') || pname.includes('ARCHIVE')) {
      pname = pname.split(' ')[0];
    } else if (pname.includes(' ')) {
      pname = pname.split(' ')[1];
    }
    switch (pname.toLowerCase()) {
      case 'corda': return <img src="./images/protocols/icons/corda_icon.svg" alt="" width={36} />;
      case 'build': return <GoRocket size={32} className="mt-1 mb-2 text-primary" />;
      case 'growth': return <IoRocketSharp size={32} className="mt-1 mb-2  text-danger" />;
      case 'developer': return <FaPaperPlane size={32} className="mt-1 mb-2 text-muted" />;
      case 'launch': return <RiRocket2Fill size={32} className="mt-1 mb-2  text-primary" />;
      case 'fabric': return <img src="./images/protocols/icons/fabric_icon.svg" alt="" width={36} />;
      case 'fluree': return <img src="./images/protocols/icons/fluree_icon.svg" alt="" width={36} />;
      case 'ethereum': return <img src="./images/protocols/icons/ethereum_icon.svg" alt="" width={36} />;
      case 'sawtooth': return <img src="./images/protocols/icons/sawtooth_icon.svg" alt="" width={36} />;
      case 'phaeton': return <img src="./images/protocols/icons/phaeton_icon.svg" alt="" width={36} />;
      case 'polygon': return <img src="./images/protocols/icons/polygon_icon.svg" alt="" width={36} />;
      case 'binance': return <img src="./images/protocols/icons/binance_icon.svg" alt="" width={36} />;
      case 'dcomm': return <img src="./images/protocols/icons/dcomm_icon.svg" alt="" width={36} />;
      case 'tron': return <img src="./images/protocols/icons/tron_icon.svg" alt="" width={36} />;
      case 'avalanche': return <img src="./images/protocols/icons/avalanche_icon.svg" alt="" />;
      case 'avalanche-subnets': return <img src="./images/protocols/icons/avalanche_icon.svg" alt="" width={36} />;
      case 'axia': return <img src="./images/protocols/icons/axia_icon.svg" alt="" width={36} />;
      case 'fantom': return <img src="./images/protocols/icons/fantom_icon.svg" alt="" width={36} />;
      case 'polkadot': return <img src="./images/protocols/icons/polkadot_icon.svg" alt="" width={36} />;
      case 'okc': return <img src="./images/protocols/icons/okx_icon.svg" alt="" width={36} />;
      case 'coreum': return <img src="./images/protocols/icons/Coreum_icon.svg" alt="" width={36} />;
      case 'edge': return <img src="./images/protocols/icons/polygon_edge_icon.svg" alt="" width={36} />;
      case 'polygon-edge': return <img src="./images/protocols/icons/polygon_edge_icon.svg" alt="" width={36} />;
      case 'polygon-cdk-chain': return <img src="./images/protocols/icons/polygon_cdk_chain_icon.svg" alt="" />;
      case 'shardeum': return <img src="./images/protocols/icons/shardeum_icon.svg" alt="" width={36} />;
      case 'web': return <img src="./images/protocols/icons/energy_web_icon.svg" alt="" width={36} />;
      case 'energy-web': return <img src="./images/protocols/icons/energy_web_icon.svg" alt="" width={36} />;
      case 'besu': return <img src="./images/protocols/icons/besu_icon_logo.svg" alt="" width={36} />;
      case 'hyperledger-besu': return <img src="./images/protocols/icons/hyperledger_besu_icon.svg" alt="" width={36} />;
      case 'acala': return <img src="./images/protocols/icons/acala_icon.svg" alt="" width={36} />;
      case 'algorand': return <img src="./images/protocols/icons/algorand_icon.svg" alt="" width={36} />;
      case 'arbitrum': return <img src="./images/protocols/icons/arbitrum_orbit_icon.svg" alt="" width={36} />;
      case 'aurora': return <img src="./images/protocols/icons/aurora_icon.svg" alt="" width={36} />;
      case 'base': return <img src="./images/protocols/icons/base_icon.svg" alt="" width={36} />;
      case 'base-blockchain': return <img src="./images/protocols/icons/base_icon.svg" alt="" width={36} />;
      case 'bitcoin': return <img src="./images/protocols/icons/bitcoin_icon.svg" alt="" width={36} />;
      case 'dogecoin': return <img src="./images/protocols/icons/dogecoin_icon.svg" alt="" width={36} />;
      case 'etherlink': return <img src="./images/protocols/icons/etherlink_icon.svg" alt="" width={36} />;
      case 'harmony': return <img src="./images/protocols/icons/harmony_icon.svg" alt="" width={36} />;
      case 'klaytn': return <img src="./images/protocols/icons/klaytn_icon.svg" alt="" width={36} />;
      case 'kusama': return <img src="./images/protocols/icons/kusama_icon.svg" alt="" width={36} />;
      case 'moonbean': return <img src="./images/protocols/icons/moonbean_icon.svg" alt="" width={36} />; // Double-check this
      case 'near': return <img src="./images/protocols/icons/near_icon.svg" alt="" width={36} />;
      case 'optimism': return <img src="./images/protocols/icons/opstack_icon.svg" alt="" width={36} />;
      case 'provenance_blockchain': return <img src="./images/protocols/icons/provenance_blockchain_icon.svg" alt="" width={36} />;
      case 'tezos': return <img src="./images/protocols/icons/tezos_icon.svg" alt="" width={36} />;
      case 'aptos': return <img src="./images/protocols/icons/aptos_icon.svg" alt="" width={36} />;
      case 'cardano': return <img src="./images/protocols/icons/cardano_icon.svg" alt="" width={36} />;
      case 'celo': return <img src="./images/protocols/icons/celo_icon.svg" alt="" width={36} />;
      case 'cosmos': return <img src="./images/protocols/icons/cosmos_icon.svg" alt="" width={36} />;
      case 'cross-fi': return <img src="./images/protocols/icons/cross_fi_icon.svg" alt="" width={36} />;
      case 'cronos': return <img src="./images/protocols/icons/cronos_icon.svg" alt="" width={36} />;
      case 'flow': return <img src="./images/protocols/icons/flow_icon.svg" alt="" width={36} />;
      case 'fuse': return <img src="./images/protocols/icons/fuse_icon.svg" alt="" width={36} />;
      case 'gnosis-chain': return <img src="./images/protocols/icons/gnosis_chain_icon.svg" alt="" width={36} />;
      case 'hedera': return <img src="./images/protocols/icons/hedera_icon.svg" alt="" width={36} />;
      case 'lisk': return <img src="./images/protocols/icons/lisk_icon.svg" alt="" width={36} />;
      case 'nervos': return <img src="./images/protocols/icons/nervos_icon.svg" alt="" width={36} />;
      case 'persistence': return <img src="./images/protocols/icons/persistence_icon.svg" alt="" width={36} />;
      case 'solana': return <img src="./images/protocols/icons/solana_icon.svg" alt="" width={36} />;
      case 'stacks': return <img src="./images/protocols/icons/stacks_icon.svg" alt="" width={36} />;
      case 'ton': return <img src="./images/protocols/icons/ton_icon.svg" alt="" width={36} />;
      case 'telos': return <img src="./images/protocols/icons/telos_icon.svg" alt="" width={36} />;
      case 'xdc': return <img src="./images/protocols/icons/xdc_icon.svg" alt="" width={36} />;
      case 'zkevm': return <img src="./images/protocols/icons/zkevm_icon.svg" alt="" />;
      case 'zksync-era': return <img src="./images/protocols/icons/zksync_icon.svg" alt="" width={36} />;
      case 'enterprise': return <img src="./images/protocols/icons/corda_icon.svg" alt="" width={36} />;
      case 'indexing': return <img src="./img/zeeve/subgraph.svg" alt="" width={36} />;
      case 'graph': return <img src="./img/zeeve/subgraph.svg" alt="" width={36} />;
      case 'node': return <img src="./img/zeeve/subgraph.svg" alt="" width={36} />;
      case 'subquery': return <img src="./img/zeeve/subgraph.svg" alt="" width={36} />;
      case 'starknet': return <img src="./images/protocols/icons/starknet_icon.svg" alt="" width={36} />;
      case 'era': return <img src="./images/protocols/icons/zksync_icon.svg" alt="" width={36} />;
      case 'blockchain': return <img src="./images/protocols/icons/provenance_blockchain_icon.svg" alt="" width={36} />;
      case 'cdk': return <img src="./images/protocols/icons/zkevm_icon.svg" alt="" width={36} />;
      case 'subnet': return <img src="./images/protocols/icons/avalanche_icon.svg" alt="" width={36} />;
      case 'bahamut': return <img src="./images/protocols/icons/fastex_icon.svg" alt="" width={36} />;
      case 'zksyncera': return <img src="./images/protocols/icons/zksync_icon.svg" alt="" width={36} />;
      case 'parachains': return <img src="./images/protocols/icons/parachains_icon.svg" alt="" width={36} />;
      case 'opstack': return <img src="./images/protocols/icons/opstack_icon.svg" alt="" width={36} />;
      case 'orbit': return <img src="./images/protocols/icons/arbitrum_orbit_icon.svg" alt="" width={36} />;
      case 'shido': return <img src="./images/protocols/icons/shido_icon.svg" alt="" width={36} />;
      case 'subsquid': return <img src="./images/protocols/icons/subsquid_icon.svg" alt="" width={36} />;
      case 'beam': return <img src="./images/protocols/icons/beam_icon.svg" alt="" width={36} />;
      case 'l1': return <img src="./images/protocols/icons/beam_icon.svg" alt="" width={36} />;
      case 'beaml1': return <img src="./images/protocols/icons/beam_icon.svg" alt="" width={36} />;
      default: return <img src="" alt="" />;
    }
  };
  return (
        <div className="d-flex" style={{ gap: '10px' }}>
            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3" style={{ width: '32px', height: '32px', alignSelf: 'center' }}>
              <ImagesProtocol />
            </div>
            <div className="col-xl-6 col-lg-6 col-md-7 col-sm-7" style={{ width: '100px' }}>
                <p className="mb-1">
                    {' '}
                    <strong>
                        {' '}
                        {name}
                    </strong>
                    {' '}
                </p>
                <div className="progress" style={{ height: 5, width: 100 }}>
                    <div className="progress-bar" role="progressbar" style={{ width: `${(distCount / totalCount) * 100}%` }} aria-valuenow={(distCount / totalCount) * 100} aria-valuemin={0} aria-valuemax={100} />
                </div>
            </div>
        </div>
  );
};
export default Protocol;
